import { ROUTES, MENU_LABELS } from '../../config/constants';

export const MainNav = [
  {
    icon: 'ni-dashboard',
    label: MENU_LABELS.DASHBOARD,
    to: ROUTES.DASHBOARD,
    exact: true,
  },
  {
    icon: 'ni-calendar',
    label: MENU_LABELS.EVENT_DIARY,
    to: ROUTES.ASSIGNMENTS,
    matchPrefix: ROUTES.ASSIGNMENTS,
  },
  {
    icon: 'ni-notice',
    label: MENU_LABELS.ANNOUNCEMENT,
    to: ROUTES.STUDY_MATERIAL,
    matchPrefix: ROUTES.STUDY_MATERIAL,
  },
  {
    icon: 'ni-play',
    label: MENU_LABELS.RESOURCES_NEXUS,
    to: ROUTES.STREAMS,
    matchPrefix: ROUTES.STREAMS,
  },
  {
    icon: 'ni-video',
    label: MENU_LABELS.IAEPT_MEETING,
    to: ROUTES.CONFERENCES,
    matchPrefix: ROUTES.CONFERENCES,
  },
  {
    icon: 'ni-check-circle',
    label: MENU_LABELS.CIVIC_CONSENSUS,
    to: ROUTES.QUIZ,
    matchPrefix: ROUTES.QUIZ,
  },
  {
    icon: 'ni-chat',
    label: MENU_LABELS.CHAT_WITH_ARBITRATOR,
    to: ROUTES.FEEDBACK,
  },
  {
    icon: 'ni-gift',
    label: MENU_LABELS.REFERRAL_REWARDS,
    to: ROUTES.REFERRAL_REWARDS,
    matchPrefix: ROUTES.REFERRAL_REWARDS,
  },
  {
    icon: 'ni-medal',
    label: MENU_LABELS.GEA,
    to: ROUTES.GEA,
    matchPrefix: ROUTES.GEA,
  },
  {
    icon: 'ni-clip',
    label: MENU_LABELS.SUBMIT_REFERRAL_DETAILS,
    to: ROUTES.SUBMIT_REFERRAL_DETAILS,
  },
  {
    icon: 'ni-wallet-out',
    label: MENU_LABELS.REFERRAL_WALLET,
    to: ROUTES.REFERRAL_WALLET,
  },
  {
    icon: 'ni-compass',
    label: MENU_LABELS.TAKE_A_TOUR,
    to: ROUTES.TOUR,
    matchPrefix: ROUTES.TOUR,
  },
  {
    icon: 'ni-notes',
    label: MENU_LABELS.REWARD_PORTFOLIO,
    to: ROUTES.REWARD_PORTFOLIO,
    matchPrefix: ROUTES.REWARD_PORTFOLIO,
  },
  {
    icon: 'ni-user-alt',
    label: MENU_LABELS.PROFILE,
    to: ROUTES.SETTINGS,
  },
];
